module.exports = __webpack_public_path__ + "static/media/janaki-mandir.afe85794.jpg";